import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    isOpen: true,
    language: 'de',
    category: null,
    general: {
      artists: null,
      originalTitle: null,
      englishTitle: null,
      year: null,
      countries: null,
      videoLink: null,
      videoPassword: null,
      biography: null
    },
    film: {
      specification: null,
      script: null,
      camera: null,
      editing: null,
      animation: null,
      music: null,
      sound: null,
      cast: null,
      synopsis: null,
      premiere: null,
      festivals: null,
      prizes: null,
      hours: null,
      minutes: null,
      seconds: null,
      runtime: '00:00:00',
      format: null,
      dialogs: null,
      language: null,
      subtitles: null,
      subtitleLanguage: null,
      student: null,
      university: null,
      info: null
    },
    artist: {
      firstName: null,
      lastName: null,
      company: null,
      address: null,
      postalCode: null,
      city: null,
      country: null,
      phone: null,
      mail: null,
      website: null,
      distribution: null
    },
    review: {
      broadcasting: false,
      publishing: false,
      tour: false,
      regulations: false
    },
    categoryFinished: false,
    generalFinished: false,
    filmFinished: false,
    artistFinished: false,
    allFinished: false
  },
  mutations: {
    setLanguage (state, payload) {
      state.language = payload
    },
    setCategory (state, payload) {
      state.category = payload
    },
    setGeneral (state, payload) {
      state.general = payload
    },
    setFilm (state, payload) {
      state.film = payload
    },
    setArtist (state, payload) {
      state.artist = payload
    },
    setProducer (state, payload) {
      state.producer = payload
    },
    setReview (state, payload) {
      state.review = payload
    },
    setState (state, payload) {
      state = payload
    },
    setCategoryFinished (state, payload) {
      state.categoryFinished = payload
    },
    setGeneralFinished (state, payload) {
      state.generalFinished = payload
    },
    setFilmFinished (state, payload) {
      state.filmFinished = payload
    },
    setArtistFinished (state, payload) {
      state.artistFinished = payload
    },
    setProducerFinished (state, payload) {
      state.producerFinished = payload
    },
    setAllFinished (state, payload) {
      state.allFinished = payload
    }
  }
})
